import React from 'react';
import { useSelector } from 'react-redux';
import FeatureTab from './FeatureTab';
import { FeatureToggle } from '@components/common';
import renderShared from '@components/common/Dashboard/SharedTabs';
import DashboardPrompt from '@components/common/DashboardNavigator/DashboardModal';
import featureNames, { globalFeatureNames } from '@utils/featureToggle/constants';
import { isCDNAccountSelector } from '@store/common/selectors';
import AccessWrapper from './AccessWrapper';
import SavedDashboardsTab from './SavedDashboardsTab';
import TemporaryDashboardTabs from './TemporaryDashboardTabs';
import DashboardList from './DashboardList';
import {
  TAB_TITLE_AI_ALERT,
  TAB_TITLE_METRIC_LENS,
  TAB_TITLE_OVB,
  TAB_TITLE_TRENDS,
  VIEWER_MODULE,
  TAB_TITLE_AI_ROADMAP,
  TAB_TITLE_NOC,
  TAB_TITLE_AI_ALERTS_COHORTS,
  isAdModule,
} from '@utils/constants';
import UseCases from '../UseCases';
import { useGlobalFeature } from '@src/globalStore/globalFeatureFlagsStore';

const EIAITabs = ({ shareId }) => {
  const renderSharedTab = renderShared(shareId);
  const isPartnerAccount = useSelector(isCDNAccountSelector);
  const enableDPICustomDimension = useGlobalFeature(globalFeatureNames.DPI_CUSTOM_DIMENSION);

  return (
    <>
      <UseCases />

      {!isPartnerAccount && (
        <FeatureTab
          tabKey="experience"
          isGA={false}
          feature={featureNames.EXPERIENCE_DASHBOARD}
          tabTitle={TAB_TITLE_OVB}
          route="/dashboard/overview"
          exact
        />
      )}

      <FeatureTab
        tabKey="trends"
        isGA
        feature={null}
        tabTitle={TAB_TITLE_TRENDS}
        route="/dashboard/trends"
        exact
      />

      <FeatureTab
        tabKey="metric-lens"
        isGA={false}
        feature={featureNames.ML}
        tabTitle={TAB_TITLE_METRIC_LENS}
        route="/dashboard/metriclens"
        exact
      />

      <FeatureTab
        tabKey="real-time"
        isGA
        feature={featureNames.NOC}
        tabTitle={<span>{TAB_TITLE_NOC}</span>}
        route="/dashboard/real-time"
        exact
      />

      {!isAdModule ? (
        <>
          <FeatureTab
            tabKey="ai-alerts"
            isGA={false}
            feature={featureNames.AI_ALERTS}
            tabTitle={TAB_TITLE_AI_ALERT}
            route="/dashboard/ai-alerts"
            exact
          />
          {!enableDPICustomDimension ? (
            <FeatureTab
              tabKey="ai-alerts-cohorts"
              isGA={false}
              feature={featureNames.AI_ALERTS}
              tabTitle={TAB_TITLE_AI_ALERTS_COHORTS}
              route="/dashboard/ai-cohorts"
              exact
            />
          ) : null}
        </>
      ) : null}

      <FeatureTab
        tabKey="alerts"
        isGA={false}
        feature={featureNames.ALERT_DIAGNOSTICS}
        tabTitle="Manual Alerts"
        route="/alert/manual/summary"
        exact={false}
      />

      <FeatureTab
        tabKey="ai-roadmap"
        isGA={false}
        feature={featureNames.AI_ROADMAP}
        tabTitle={TAB_TITLE_AI_ROADMAP}
        route="/dashboard/ai-roadmap"
        exact
      />

      <FeatureTab
        tabKey="viewer-module"
        isGA={false}
        feature={featureNames.VIEWER_MODULE_PULSE5}
        tabTitle={VIEWER_MODULE}
        route="/dashboard/viewer-module"
        exact
      />

      <AccessWrapper feature={featureNames.SAVED_DASHBOARDS}>
        <SavedDashboardsTab />
      </AccessWrapper>

      <TemporaryDashboardTabs renderSharedTab={renderSharedTab} activeId={`${shareId}`} />

      <FeatureToggle feature={featureNames.SAVED_DASHBOARDS} checkRole>
        <>
          <DashboardList id={`${shareId}`} />
        </>
      </FeatureToggle>

      <DashboardPrompt />
    </>
  );
};

export default EIAITabs;
